export const OPEN_LOGAN_SUPPORT_TICKET_EVENT = "open-logan-support-ticket";
export const LOGAN_WORKFLOW_ERROR_EVENT = "logan-workflow-error";
export const LOGAN_SUPPORT_TICKET_CREATED_EVENT = "logan-support-ticket-created";

export function openLoganSupportTicket() {
  window.dispatchEvent(new CustomEvent(OPEN_LOGAN_SUPPORT_TICKET_EVENT));
}

export function notifyLoganWorkflowError(status: number) {
  window.dispatchEvent(new CustomEvent(LOGAN_WORKFLOW_ERROR_EVENT, { detail: { status } }));
}

export function notifyLoganSupportTicketCreated() {
  window.dispatchEvent(new CustomEvent(LOGAN_SUPPORT_TICKET_CREATED_EVENT));
}
